import { cn } from '@/utils/cn';
import { Loader2 } from 'lucide-react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'overlay';
  className?: string;
}

const sizeClasses = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8'
};

export const Spinner = ({ size = 'md', variant = 'overlay', className }: SpinnerProps) => {
  const spinner = (
    <Loader2
      className={cn('text-typography-900 animate-spin', sizeClasses[size], className)}
      role="status"
      aria-label="Loading"
    />
  );

  if (variant === 'overlay') {
    return (
      <div className="pointer-events-none fixed left-24 z-[9999] flex h-full min-h-screen w-full items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
};
